import { AxiosError } from 'axios';
import { ConfigurationType } from 'web-library/models/DropDown';
import { GET_RECORD_STATUS_URL } from '../../constants/apiUrls';
import { GET_RECORD_STATUS_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: string[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetRecordStatus = ({ onError, onSuccess }: Input) => {
  const getRecordStatuses = async () => {
    const res = await axiosClient.get<ConfigurationType[]>(GET_RECORD_STATUS_URL);

    return res.data;
  };

  return useCustomQuery([GET_RECORD_STATUS_KEY], getRecordStatuses, {
    onSuccess,
    onError,
  });
};
